import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Client-side gate only — it decides what to render, never what is permitted.
 * Every backoffice endpoint re-validates the token against staff_users, so
 * bypassing this guard buys an attacker an empty page and a string of 401s.
 */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isAuthenticated() ? true : router.createUrlTree(['/login']);
};
